import React from 'react';
import InvoiceCard from "./InvoiceCard/InvoiceCard";
import InfoCardLoadingSkeleton from "../../../skeleton/InfoCardLoadingSkeleton";
import {Grid} from "@mui/material";
import type {Account} from "../../../../types/Account";
import type {InvoiceTransactionVO as AdminInvoiceTransaction} from "../../../../types/model/valueObject/invoice/InvoiceTransactionVO";
import {OnInvoiceActionCallback} from "./InvoiceActions";

interface InvoiceListProps {
  account: Account;
  invoices: AdminInvoiceTransaction[];
  loading?: boolean;
  onInvoiceAction: OnInvoiceActionCallback;
}

/**
 * Renders a list of invoice cards for the admin invoices report.
 *
 * @param account The account of the logged in user.
 * @param invoices The list of invoices to render.
 * @param loading Determines whether to show a loading skeleton instead of the actual invoice cards.
 * @param onInvoiceAction The callback to be called when an action on an invoice card is successful.
 */
const InvoiceList = ({
  account,
  invoices,
  loading = false,
  onInvoiceAction,
}: InvoiceListProps) => {
  return (<Grid item container direction={'column'}>
      {
        loading ? <InfoCardLoadingSkeleton /> : invoices.map((invoice) => (
          <InvoiceCard
            account={account}
            key={invoice.transactionId}
            invoice={invoice}
            onInvoiceAction={onInvoiceAction}
          />
        ))
      }
    </Grid>
  )
};

export default InvoiceList;
